import { PASSES } from "../data/content";
import { PageIntro } from "../components/PageIntro";
import { Reveal } from "../components/Reveal";
import { BookButton, LinkButton } from "../components/Button";

export default function Passes() {
  return (
    <div data-testid="passes-page">
      <PageIntro
        label="Passes"
        titleLines={["Two ways", "to spend", "the day."]}
        blurb="One pass, one price, all of the water and the rooms. Prices vary by day and time — browse the shop."
      />

      <div className="mx-auto max-w-[1600px] px-5 pb-24 md:px-10 md:pb-36">
        <div className="grid gap-px border border-ink bg-ink lg:grid-cols-2">
          {PASSES.map((p, i) => (
            <Reveal key={p.name} immediate delay={i * 0.08} className="bg-cream">
              <div className="flex h-full flex-col p-8 md:p-14">
                <div className="flex items-baseline justify-between">
                  <span className="text-xs uppercase tracking-[0.2em] text-terracotta">
                    0{i + 1}
                  </span>
                  <span className="text-sm uppercase tracking-[0.15em] text-ink/60">{p.duration}</span>
                </div>
                <h2 className="mt-8 text-5xl font-medium tracking-tight md:text-7xl">{p.name}</h2>
                <p className="mt-6 max-w-sm text-lg font-normal leading-relaxed text-ink/70">{p.line}</p>
                <p className="mt-auto pt-14 text-3xl font-medium tracking-tight md:text-4xl">{p.price}</p>
                <div className="mt-8 flex flex-wrap gap-3">
                  <BookButton />
                  <LinkButton to="/amenities" variant="outline">
                    See what's included
                  </LinkButton>
                </div>
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </div>
  );
}
